import { EventApplyOption, EventType } from 'modules/calendar/core/enum';

import { getNextRoundedHour } from 'helpers';

export const ITEMS_PER_PAGE = 10;

export const INITIAL_FORM_STATE = (endRepeatValue: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return {
    eventType: EventType.Class,
    selectedClassId: undefined,
    eventName: '',
    startDate: new Date(),
    endDate: new Date(),
    startTime: getNextRoundedHour().startTime,
    endTime: getNextRoundedHour().endTime,
    selectedCenterId: undefined,
    selectedContentId: undefined,
    description: '',
    selectedLevel: undefined,
    selectedCategory: undefined,
    image: '',
    recurringRule: 'none',
    selectedInvitees: [],
    count: endRepeatValue.value === 'after' ? 2 : undefined,
    recurringEnd: new Date(),
    applyOption: EventApplyOption.ONLY_THIS_EVENT,
    invitees: {
      trainers: {
        items: [],
      },
      clients: {
        items: [],
      },
    },
    qrKey: '',
  };
};

export const TIME_FORMAT = 'HH:mm';
